/* src/app/shared/components/flow-tab/flow-tab.component.scss */
.tabs-container {
  position: relative;
  height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;
  -webkit-user-select: none;
  user-select: none;
  padding: 8px;
}
.tabs-container .selection-pill {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 0;
  border-radius: 8px;
  opacity: 0;
  pointer-events: none;
  will-change: transform, width;
}
.tabs-container .selection-pill.animated {
  transition:
    transform 250ms cubic-bezier(0.4, 0, 0.2, 1),
    width 250ms cubic-bezier(0.4, 0, 0.2, 1),
    background-color 150ms ease,
    opacity 150ms ease;
}
.tabs-container .selection-pill.visible {
  opacity: 1;
}
.tabs-container .tab-wrapper {
  position: relative;
  z-index: 1;
}
.tabs-container .tab-wrapper.disabled {
  cursor: not-allowed;
}
.tabs-container .tab-wrapper.disabled img {
  filter: brightness(0) saturate(100%) invert(87.5%) !important;
}
.tabs-container .tab-wrapper.disabled p {
  color: #71717a !important;
}
.tabs-container .tab-wrapper .flow-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 8px 12px;
  cursor: pointer;
  gap: 8px;
  border-radius: 8px;
}
.tabs-container .tab-wrapper .flow-tab.disabled {
  cursor: not-allowed;
}
.tabs-container .tab-wrapper .flow-tab img {
  width: 16px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(279%) hue-rotate(202deg) brightness(95%) contrast(85%);
}
.tabs-container .tab-wrapper .flow-tab img.color-neutral {
  filter: brightness(0) saturate(100%) invert(57%) sepia(80%) saturate(526%) hue-rotate(200deg) brightness(12%) contrast(59%);
}
.tabs-container .tab-wrapper .flow-tab img.color-red {
  filter: brightness(0) saturate(100%) invert(27%) sepia(57%) saturate(2736%) hue-rotate(341deg) brightness(74%) contrast(108%);
}
.tabs-container .tab-wrapper .flow-tab img.color-orange {
  filter: brightness(0) saturate(100%) invert(27%) sepia(91%) saturate(3351%) hue-rotate(13deg) brightness(87%) contrast(91%);
}
.tabs-container .tab-wrapper .flow-tab img.color-yellow {
  filter: brightness(0) saturate(100%) invert(35%) sepia(97%) saturate(466%) hue-rotate(357deg) brightness(96%) contrast(97%);
}
.tabs-container .tab-wrapper .flow-tab img.color-green {
  filter: brightness(0) saturate(100%) invert(26%) sepia(97%) saturate(5418%) hue-rotate(147deg) brightness(91%) contrast(84%);
}
.tabs-container .tab-wrapper .flow-tab img.color-teal {
  filter: brightness(0) saturate(100%) invert(23%) sepia(29%) saturate(6150%) hue-rotate(160deg) brightness(96%) contrast(88%);
}
.tabs-container .tab-wrapper .flow-tab img.color-blue {
  filter: brightness(0) saturate(100%) invert(32%) sepia(84%) saturate(940%) hue-rotate(200deg) brightness(98%) contrast(85%);
}
.tabs-container .tab-wrapper .flow-tab img.color-brand {
  filter: brightness(0) saturate(100%) invert(32%) sepia(84%) saturate(940%) hue-rotate(200deg) brightness(98%) contrast(85%);
}
.tabs-container .tab-wrapper .flow-tab img.color-purple {
  filter: brightness(0) saturate(100%) invert(20%) sepia(51%) saturate(5242%) hue-rotate(267deg) brightness(84%) contrast(101%);
}
.tabs-container .tab-wrapper .flow-tab img.color-pink {
  filter: brightness(0) saturate(100%) invert(19%) sepia(37%) saturate(4917%) hue-rotate(315deg) brightness(99%) contrast(103%);
}
.tabs-container .tab-wrapper .flow-tab .notification {
  display: flex;
  min-width: 20px;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
}
.tabs-container .tab-wrapper .flow-tab:not(.selected):not(.disabled):hover {
  background-color: #f4f4f5;
}
/*# sourceMappingURL=flow-tab.component.css.map */
